interface IExternalAuthButtonProps {
  icon: React.ElementType
  // platformName: string
  onClick: () => void
  disabled?: boolean
}

const ExternalAuthButton = ({
  icon: Icon,
  onClick,
  disabled = false
}: IExternalAuthButtonProps) => {
  return (
    <button
    className={`flex h-[48px] flex-1 items-center justify-center rounded-[40px] border border-[#EDEDED] bg-white transition-all duration-200 ${
      disabled 
        ? 'opacity-50 cursor-not-allowed' 
        : 'hover:bg-gray-50 hover:border-gray-300 active:scale-95'
    }`}
    type='button'
    onClick={onClick}
    disabled={disabled}
  >
    {disabled ? (
      <div className="w-6 h-6 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
    ) : (
      <Icon className="w-6 h-6" />
    )}
  </button>
  )
}

export default ExternalAuthButton
